module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAASCAYAAABWzo5XAAAAAXNSR0IArs4c6QAAAARzQklUCAgICHwIZIgAAAA3SURBVDiNY2QgE/wvkFBg+Pf/PozPRK5B6GDUoFGDRg2ij0Es/wskFMjUi6KPBbkooAQMvjACAOLQCU6o++DJAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/qr-code-4.png
// module id = IMng
// module chunks = 1